import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router } from '@angular/router';
import { ErrorCode } from 'app/shared/models/error.models';

export const UsernameResolver: ResolveFn<string> = (route: ActivatedRouteSnapshot) => {
  const router: Router = inject(Router);
  const username: string | null = route.paramMap.get('username');

  if (!username)
    return new RedirectCommand(router.parseUrl(`/error/${ErrorCode.CONTEST_CODE_NOT_FOUND}`));
  return username;
};
